import { MARQUEE_TEXT } from "../data/content";

export const Marquee = () => (
    <div
        data-testid="marquee"
        className="mt-20 md:mt-32 border-y border-[var(--line)] py-4 md:py-6 overflow-hidden"
        aria-hidden="true"
    >
        <div className="marquee-track">
            {[0, 1].map((n) => (
                <span
                    key={n}
                    className="font-display uppercase whitespace-nowrap text-lg md:text-3xl tracking-tight pr-4"
                >
                    {MARQUEE_TEXT.repeat(3)}
                </span>
            ))}
        </div>
    </div>
);
